import { jsx as _jsx } from "react/jsx-runtime";
import { parseBusinessDate } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { DisplayText } from '../../display-text';
const b = bemClassBuilder('v-date-picker-date');
export const DatePickerDate = observer(props => {
    const { value, onClick, dateFormat } = props;
    const { businessDate, isActive, isSelected, isToday } = props.value;
    const handleClick = () => onClick(value.businessDate);
    return (_jsx("li", Object.assign({ className: b.block() }, { children: _jsx("button", Object.assign({ className: b.element('button', { selected: isSelected, inactive: !isActive }), onClick: handleClick }, { children: _jsx(DisplayText, { label: dateFormat, templateParameters: { date: parseBusinessDate(businessDate) }, className: b.element('label', { today: isToday }) }) })) })));
});
DatePickerDate.displayName = 'DatePickerDate';
